import script from "./BottomMsg.vue?vue&type=script&lang=ts&setup=true"
export * from "./BottomMsg.vue?vue&type=script&lang=ts&setup=true"

import "./BottomMsg.vue?vue&type=style&index=0&id=686dd518&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-686dd518"]])

export default __exports__